import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
// guards
import AuthGuard from '../guards/AuthGuard';
// layouts
import DashboardLayout from '../layouts/dashboard';
//
import { PATH_DASHBOARD, PATH_DOCS } from './paths';

// ----------------------------------------------------------------------

const DashboardRoutes = {
  path: PATH_DASHBOARD.root,
  guard: AuthGuard,
  layout: DashboardLayout,
  routes: [
    // GENERAL
    // ----------------------------------------------------------------------
    {
      path: PATH_DASHBOARD.general.app,
      component: lazy(() => import('../views/GeneralApp'))
    },
    // {
    //   exact: true,
    //   path: PATH_DASHBOARD.general.ecommerce,
    //   component: lazy(() => import('../views/GeneralEcommerce'))
    // },
    {
      path: PATH_DASHBOARD.general.analytics,
      component: lazy(() => import('../views/GeneralAnalytics'))
    },
    {
      path: PATH_DASHBOARD.root,
      component: () => <Navigate to={PATH_DASHBOARD.general.app} />
    },

    // MANAGEMENT : USER
    // ----------------------------------------------------------------------
    // {
    //   exact: true,
    //   path: PATH_DASHBOARD.user.profile,
    //   component: lazy(() => import('../views/UserProfile'))
    // },
    {
      path: PATH_DASHBOARD.user.cards,
      component: lazy(() => import('../views/UserCards'))
    },
    {
      path: PATH_DASHBOARD.user.list,
      component: lazy(() => import('../views/UserList'))
    },
    {
      path: PATH_DASHBOARD.user.create,
      component: lazy(() => import('../views/UserCreate'))
    },
    {
      path: PATH_DASHBOARD.user.account,
      component: lazy(() => import('../views/UserAccount'))
    },
    {
      path: PATH_DASHBOARD.user.edit,
      component: lazy(() => import('../views/UserEdit'))
    },
    {
      path: PATH_DASHBOARD.user.root,
      component: () => <Navigate to={PATH_DASHBOARD.user.profile} />
    },

    // MANAGEMENT : INVENTORY
    // ----------------------------------------------------------------------
    {
      path: PATH_DASHBOARD.inventory.root,
      component: lazy(() => import('../views/VehicleFind'))
    },
    {
      path: PATH_DASHBOARD.inventory.findVehicle,
      component: lazy(() => import('../views/VehicleFind'))
    },
    {
      path: PATH_DASHBOARD.inventory.viewVehicle,
      component: lazy(() => import('../views/VehicleView'))
    },
    {
      path: PATH_DASHBOARD.inventory.viewPdf,
      component: lazy(() => import('../views/PdfView'))
    },
    {
      path: PATH_DASHBOARD.inventory.addVehicle,
      component: lazy(() => import('../views/VehicleCreate'))
    },
    {
      path: PATH_DASHBOARD.inventory.editVehicle,
      component: lazy(() => import('../views/VehicleEdit'))
    },
    {
      path: PATH_DASHBOARD.inventory.bulkUploadVehicle,
      component: lazy(() => import('../views/VehicleBulkUpload'))
    },
    // MANAGEMENT : COMPANIES
    // ----------------------------------------------------------------------
    {
      path: PATH_DASHBOARD.company.root,
      component: () => <Navigate to={PATH_DASHBOARD.company.list} />
    },
    {
      path: PATH_DASHBOARD.company.list,
      component: lazy(() => import('../views/CompanyList'))
    },
    {
      path: PATH_DASHBOARD.company.create,
      component: lazy(() => import('../views/CompanyCreate'))
    },
    {
      path: PATH_DASHBOARD.company.edit,
      component: lazy(() => import('../views/CompanyEdit'))
    },
    // MANAGEMENT : BRANDS
    // ----------------------------------------------------------------------
    {
      path: PATH_DASHBOARD.brand.root,
      component: () => <Navigate to={PATH_DASHBOARD.brand.list} />
    },
    {
      path: PATH_DASHBOARD.brand.list,
      component: lazy(() => import('../views/BrandList'))
    },
    {
      path: PATH_DASHBOARD.brand.create,
      component: lazy(() => import('../views/BrandCreate'))
    },
    {
      path: PATH_DASHBOARD.brand.edit,
      component: lazy(() => import('../views/BrandEdit'))
    },
    // MANAGEMENT : BRANCHES
    // ----------------------------------------------------------------------
    {
      path: PATH_DASHBOARD.branch.root,
      component: () => <Navigate to={PATH_DASHBOARD.branch.list} />
    },
    {
      path: PATH_DASHBOARD.branch.list,
      component: lazy(() => import('../views/BranchList'))
    },
    {
      path: PATH_DASHBOARD.branch.create,
      component: lazy(() => import('../views/BranchCreate'))
    },
    {
      path: PATH_DASHBOARD.branch.edit,
      component: lazy(() => import('../views/BranchEdit'))
    },
    // MANAGEMENT : LEADS
    // ----------------------------------------------------------------------
    {
      path: PATH_DASHBOARD.lead.root,
      component: () => <Navigate to={PATH_DASHBOARD.lead.list} />
    },
    {
      path: PATH_DASHBOARD.lead.list,
      component: lazy(() => import('../views/LeadList'))
    },
    // SYSTEM
    // ----------------------------------------------------------------------
    {
      path: PATH_DASHBOARD.system.root,
      component: () => <Navigate to={PATH_DASHBOARD.system.logs} />
    },
    {
      path: PATH_DASHBOARD.system.logs,
      component: lazy(() => import('../views/CloudwatchLogs'))
    },
    // TRADE-IN : PRICING_REQUEST
    // ----------------------------------------------------------------------
    {
      path: PATH_DASHBOARD.pricingRequest.list,
      component: lazy(() => import('../views/PricingRequestList'))
    },
    {
      path: PATH_DASHBOARD.pricingRequest.edit,
      component: lazy(() => import('../views/PricingRequestEdit'))
    },
    // PAGES
    // ----------------------------------------------------------------------
    {
      component: () => <Navigate to="/404" />
    },
    // MANAGEMENT : DOCUMENTATION
    // ----------------------------------------------------------------------
    {
      path: PATH_DOCS.root,
      component: lazy(() => import('../views/DocumentationPage'))
    }
  ]
};

export default DashboardRoutes;
